import React from 'react';
import { PaperClipIcon } from '@heroicons/react/24/outline';

/**
 * Un adjunto del que tenemos la constancia pero no el fichero.
 *
 * 🔴 Existe porque los tres componentes de adjunto hacían `if (!url) return null`
 * y el mensaje **desaparecía entero del chat**. No se veía sin enlace: no se
 * veía. Un deudor que manda su justificante de pago por WhatsApp y una
 * conversación en la que no pasó nada eran indistinguibles en pantalla.
 *
 * Pasa con todo lo que captura el NAVEGADOR —que lee la pantalla de WhatsApp
 * Web y nunca se descarga el archivo—, o sea con todos los adjuntos entrantes
 * desde el 07/08/2026, que es cuando dejó de entrar nada por la API de Maytapi.
 * También con las 788 imágenes y los 380 audios de Maytapi, que tampoco
 * guardaron fichero nunca: sólo los 277 documentos lo hicieron.
 *
 * Enseñar el hueco no arregla la captura —eso está en el brazo— pero convierte
 * «aquí no hay nada» en «aquí hay algo y no lo tenemos», que son cosas muy
 * distintas cuando lo que falta es un comprobante.
 */

const COMO_SE_LLAMA = {
  document: 'Documento',
  documento: 'Documento',
  image: 'Imagen',
  imagen: 'Imagen',
  audio: 'Audio',
  ptt: 'Audio',
  video: 'Vídeo',
  sticker: 'Sticker',
};

/**
 * El nombre del fichero, si se sabe.
 *
 * El navegador no guarda `filename`: escribe el nombre dentro del propio texto,
 * como `[document] justificante.pdf`. Se saca de ahí antes de rendirse, porque
 * el nombre es justo lo que permite pedírselo al deudor otra vez.
 */
const nombreDe = (details) => {
  if (details?.filename) return details.filename;
  const m = /^\[[^\]]+\]\s*(.+)$/.exec(String(details?.message || '').trim());
  return m ? m[1] : null;
};

const SinFichero = ({ details }) => {
  const tipo = COMO_SE_LLAMA[details?.type] || 'Adjunto';
  const nombre = nombreDe(details);

  return (
    <div className='space-y-1'>
      <div className='flex items-center gap-1.5 text-sm text-slate-600'>
        <PaperClipIcon className='w-4 h-4 flex-shrink-0 text-slate-400' />
        <span className='break-all'>{nombre || tipo}</span>
      </div>
      <div className='text-[11px] text-amber-700'>
        {tipo} recibido — no se guardó el fichero
      </div>
      {details?.caption && (
        <div className='text-xs text-gray-600 whitespace-pre-wrap break-words'>{details.caption}</div>
      )}
    </div>
  );
};

export default SinFichero;
